/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const facebook_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18 8.007h-4.17v-1.91c-.055-.562.4-1.102.98-1.099h2.935V1h-4.238c-3.846 0-4.57 2.999-4.57 4.858v2.149H6v3.998h2.936V23h4.894V12.005h3.77l.4-3.998Z"
    />
  </svg>
)
export default facebook_medium
